/**
 * Toggles the specified attribute of a given field and updates its validation
 * data attribute accordingly.
 *
 * @param {HTMLElement} field - The field to toggle the attribute on.
 * @param {string} attribute - The attribute to toggle.
 * @param {boolean} toggle - Whether to toggle the attribute on or off.
 * @returns {void}
 * @since 3.0.0
 */
export function toggleFieldAttributeV2(field, attribute, toggle) {
    const validation = field.getAttribute("data-validate").split(" ");

    if (toggle) {
        if (validation.indexOf(attribute) == -1) {
            validation.push(attribute);
        }
        field.setAttribute("required", "");
    } else {
        const index = validation.indexOf(attribute);
        if (index != -1) {
            validation.splice(index, 1);
        }
        field.removeAttribute("required");
    }

    field.setAttribute("data-validate", validation.join(" "));
}
